import { makeRule } from '@core/utils/rule.js'

export let searchRules = {
  tagname: [
    {...makeRule('请输入类别名称', 'string')},
  ],
  tagdesc: [
    {...makeRule('请输入类别描述', 'string')},
  ],
  price: [
    {...makeRule('请输入标签价格', 'number')},
  ],
  file: [
    {...makeRule('请上传标签用户管理', 'string')},
  ],
}



// WEBPACK FOOTER //
// ./src/views/teke-tag/tekeTag.rules.js